import React from 'react';
import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/apply';
import Select from "react-select";
import IconTimes from '../../../icons/times';
import IconPrint from '../../../icons/print';
import { statusList } from '../../../utility/constants';
import ApplyDetailValues from './details';
import ApplyForm from './form';
import { ModalInterviewSchedule } from './ScheduleInterview/ModalInterviewSchedule';
import { InterviewDatetime } from './ScheduleInterview/InterviewDatetime';
import './ScheduleInterview/ModalInterviewSchedule.css';

const ApplyDetail = (props) => {
    const [showInterviewModal, setShowInterviewModal] = React.useState(false);

    const {
        load2Update,
        changeStateApply,
        item,
        isEdit,
        update,
        setIsEdit,
        loadingForm,
        formValues,
        history,
        match: {
            params: {
                id
            }
        }
    } = props;

    React.useEffect(() => {
        load2Update(id);
        return ()=>{
            setIsEdit(false)
        }
    }, [load2Update, setIsEdit, id]);

    const print = () => {
        window.print();
    }

    const onStatusChange = (e) => {
       const selected = e['value'];
       if (selected === 'interview_scheduled') {
          setShowInterviewModal(true);
          return;
       } else {
          changeStateApply(e['value']);
       }
    };

    const handleInterviewSubmit = (interviewDateTime, interviewTimezone) => {
       setShowInterviewModal(false);


       changeStateApply('interview_scheduled', {
          interview_datetime: interviewDateTime,
          interview_timezone: interviewTimezone,
       });
    };

    const isScheduling =
        item.status === 'interview_scheduled' ||
        (item.status && item.status.value && item.status.value === 'interview_scheduled');

    return (
        <div className="d-flex flex-wrap justify-content-center">
            <div className="col-12 mb-5">
                {isEdit ? (
                    <ApplyForm
                        onSubmit={update}
                        onCancel={()=>setIsEdit(false)}
                        loading={loadingForm}
                        formValues={formValues}
                    />
                ) : item ? (
                    <React.Fragment>
                        <div className="w-100 d-flex flex-wrap no-print">
                            <div className="col-12 d-flex flex-wrap justify-content-between">
                                <div className="d-flex align-items-start">
                                    {!isEdit ? (
                                        <div className="">
                                            <button
                                                type="button"
                                                className="btn btn-link mr-2 text-danger"
                                                onClick={()=>history.goBack()}
                                            >
                                                <IconTimes className="smallIcon text-danger" />
                                                CLOSE
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-link mr-2 text-dark"
                                                onClick={print}
                                            >
                                                <IconPrint className="smallIcon" />
                                                PRINT
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary mr-2"
                                                onClick={()=>setIsEdit(true)}
                                            >
                                                EDIT
                                            </button>
                                        </div>
                                    ) : ''}
                                </div>
                                <div className="col-12 col-md-4 px-0 mt-3 mt-md-0 select-labeled status-field">
                                    <label htmlFor="apply-status">
                                        Status
                                    </label>
                                    <div className="w-100">
                                        <Select
                                            id="apply-status"
                                            clearable={false}
                                            className=""
                                            backspaceRemovesValue={false}
                                            searchable={true}
                                            options={statusList}
                                            placeholder="Status"
                                            onChange={(e) => {
                                                onStatusChange(e)
                                            }}
                                            value={item && item.status && item.status.value ? item.status.value : "application_submitted"}
                                            disabled={false}
                                        />
                                    </div>
                                    <InterviewDatetime
                                        reschedule={() => setShowInterviewModal(true)}
                                        interview_datetime={item.interview_datetime}
                                        interview_timezone={item.interview_timezone}
                                        isScheduling={isScheduling}
                                    />
                                </div>
                            </div>
                            <div className="col-12 my-4">
                                <h4> DRIVER APPLICATION FORM </h4>
                            </div>
                        </div>
                        <ApplyDetailValues item={item}/>
                    </React.Fragment>
                    ) : (
                        <div className="">
                            <h4> No Data</h4>
                        </div>
                    )}
            </div>

            <ModalInterviewSchedule
                show={showInterviewModal}
                toggleShowModal={setShowInterviewModal}
                handleInterviewSubmit={handleInterviewSubmit}
                initialDateTime={item && item.interview_datetime ? item.interview_datetime : null}
                initialTimezone={item && item.interview_timezone ? item.interview_timezone : null}
            />
        </div>
    )
}

const mstp = (state) => ({
    ...state.apply,
    formValues: state.form.applyForm && state.form.applyForm.values,
})

const mdtp = {
    ...actions
}

export default connect(mstp, mdtp)(ApplyDetail);
